const Languages = [
  {
    code: "en",
    name: "English (EU)"
  },
  {
    code: "us",
    name: "English (US)"
  },
  {
    code: "de",
    name: "Deutsch"
  },
  {
    code: "no",
    name: "Norwegian"
  },
  {
    code: "se",
    name: "Swedish"
  }
  /*
  {
    code: 'hr',
    name: 'Croatian'
  },
  {
    code: 'it',
    name: 'Italian'
  },
  {
    code: 'ru',
    name: 'Russian'
  }
  */
];

export default Languages;
